;(function () {
  'use strict'

  angular
    .module('contrast.licenses-activity-series')
    .constant('CHART_CONFIG_ID', {
      PROTECT_SERIES_CONFIG: 'protect-series-config',
      ASSESS_SERIES_CONFIG: 'assess-agent-usage-chart',

      PROTECT_USAGE_HOURS_SERIES_CONFIG: 'protect-usage-hours-series-config',
      PROTECT_AGENT_USAGE_SERIES_CONFIG: 'protect-agent-usage-series-config'
    })
})()
